import React, { useEffect, useState } from "react";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import "../../../style/block.scss";
import "../../../style/buttons.scss";
import "../../../style/forms.scss";
import { useDispatch, useSelector } from "react-redux";
import { LoginData } from "../../models/LoginData";
import { logInWithPassword } from "../../store/auth/authActions";
import { useNavigate } from "react-router";
import { REGISTRATION_PAGE, REMIND_PASS_PAGE } from "../../routes";
import useFacility from "../../../utils/hooks/useFacility";
import { BsQuestionCircle } from "react-icons/bs";
import { State } from "../../store";
import { USER_TOKEN } from "../../store/auth/authMiddleware";
import { useTranslation } from "react-i18next";
import { clearErrors } from "../../store/alerts/alertsActions";
import EAButton from "../shared/Buttons/EAButton";
import { IoMdArrowRoundForward } from "react-icons/io";
import EADivider from "../shared/EADivider";
import LoginInputs from "./LoginInputs";

const initialFormLogin: LoginData = {
  login: "",
  password: "",
  objectIds: "",
  old_token: "",
  rememberMe: false,
};

const Login: React.FC = () => {
  const userToken = sessionStorage.getItem(USER_TOKEN);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const facilityIds = useFacility();
  const parsedUserToken = userToken ? JSON.parse(userToken).sessionToken : "";

  const alertLogin = useSelector((state: State) => state.alerts.errors);
  const loading = useSelector((state: State) => state.auth.loading);

  const [form, setForm] = useState<LoginData>({
    ...initialFormLogin,
    objectIds: facilityIds,
    old_token: parsedUserToken,
  });
  useEffect(() => {
    if (Boolean(facilityIds)) {
      setForm({ ...form, objectIds: facilityIds });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  useEffect(() => {
    dispatch(clearErrors());
    //eslint-disable-next-line
  }, []);

  return (
    <div className="auth-page flex-center-center">
      <div className="auth-box shadow ">
        <h1>{t("zaloguj_sie")}</h1>
        {/* <SocialLoginButtons /> */}

        <LoginInputs form={form} setForm={setForm} />
        <EAButton
          variant="text"
          fullWidth
          title={t("nie_pamietam_hasla")}
          onClick={() => navigate(REMIND_PASS_PAGE)}
          endIcon={<BsQuestionCircle />}
        />

        {alertLogin && alertLogin.length > 0 && <div className="alert alert-red">{alertLogin}</div>}

        <EADivider />

        <div className="flex-between-center buttons">
          <EAButton
            variant="outlined"
            fullWidth
            title={t("utworz_konto")}
            onClick={() => navigate(REGISTRATION_PAGE)}
            disabled={loading}
          />
          <EAButton
            variant="filled"
            fullWidth
            title={t("zaloguj_sie")}
            onClick={() => dispatch(logInWithPassword(form))}
            endIcon={<IoMdArrowRoundForward />}
            loading={loading}
            loadingText={t("logowanie")}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
